/* eslint-disable react-refresh/only-export-components */
import type { User } from '@/shared/types/user';
import { capitalize } from '@/lib/strings';
import { UserActions } from './actions';
import { StandardIcon } from '@/components/common/icon';
import { IconIds } from '@/lib/constants';

export type ColumnKey = keyof User['data'] | 'access' | 'actions';

export function createColumn({
  key,
  displayName = capitalize(key),
  align = 'start',
}: {
  key: ColumnKey;
  displayName?: string;
  align?: 'start' | 'center' | 'end';
}) {
  return {
    key,
    displayName,
    align,
  };
}

export function makeColumnLookup(cols: ColumnInfo[]) {
  return cols.reduce(
    (m, v) => {
      m[v.key] = v;

      return m;
    },
    {} as Record<ColumnKey, ColumnInfo>,
  );
}

export type ColumnInfo = ReturnType<typeof createColumn>;
export type ActionKey = 'edit' | 'archive' | 'invite';

export function CellDisplay({
  item,
  col,
  onAction,
}: {
  item: User;
  col: ColumnInfo;
  onAction: (item: User, action: ActionKey) => void;
}) {
  if (col.key === 'access') {
    return <UserAccess data={item.data} />;
  } else if (col.key === 'actions') {
    return <UserActions item={item} onAction={onAction} />;
  }

  return <div>{String(item.data[col.key])}</div>;
}

function UserAccess({ data }: { data: User['data'] }) {
  // const Placeholder = () => <div className='w-[20px]'></div>;
  // TODO tooltip around icons to explain what role they represent
  const AccessIcon = ({ icon, access }: { icon: string; access: boolean }) => {
    if (access) {
      return <StandardIcon id={icon} />;
    }

    return <StandardIcon id={icon} className='!text-default-200' />;
  };

  return (
    <div className='flex flex-row items-center justify-center gap-1'>
      <AccessIcon icon={IconIds.admin} access={data.admin} />
      <AccessIcon icon={IconIds.people} access={data.people} />
      <AccessIcon icon={IconIds.workflows} access={data.workflows} />
    </div>
  );
}
